/* global _ */
import {angleToIndex} from "./_utilities";

function getStepInfo(current, target, numFrames) {
	if (target > current) {
		if (target - current > numFrames / 2) {
			return {
				numSteps: numFrames - target + current,
				direction: -1
			};
		} else {
			return {
				numSteps: target - current,
				direction: 1
			};
		}
	} else if (current > target) {
		if (current - target > numFrames / 2) {
			return {
				numSteps: numFrames - current + target,
				direction: 1
			};
		} else {
			return {
				numSteps: current - target,
				direction: -1
			};
		}
	} else {
		return {
			numSteps: 0,
			direction: 0
		};
	}
}

function getIndex(currentRotationIndex, direction, numFrames) {
	if (currentRotationIndex + direction === numFrames) {
		return 0
	} else if (currentRotationIndex + direction === -1) {
		return numFrames - 1;
	} else {
		return currentRotationIndex + direction;
	}
}

/**
 * returns a stream of rotation steps
 * @param step - step direction
 * @param state
 * @param targetRotationAngle
 * @returns {*}
 */
export function rotateTruck(step, state, targetRotationAngle) {
	let numFrames = state.numFrames || 24,
		maxFrames = state.maxFrames || 24,
		prevRotationIndex = state.hideIndex,
		currentRotationIndex = state.showIndex,
		targetRotationIndex = targetRotationAngle ?
			angleToIndex(targetRotationAngle, numFrames) :
			currentRotationIndex + (step ? step : 0),
		direction = step || 0,
		stepInfo,
		steps;

	// if all angles haven't been loaded yet then just show first one
	if (numFrames !== maxFrames) {
		// console.log("frames", numFrames, maxFrames)
		targetRotationIndex = 0;
	}
	if (targetRotationAngle) {
		// compute the number of steps to turn and the direction and then create a stream with that number of steps
		stepInfo = getStepInfo(currentRotationIndex, targetRotationIndex, numFrames);
		steps = _.times(stepInfo.numSteps, _.constant(stepInfo.direction));
	}

	// console.log("rotate truck", currentRotationIndex, targetRotationIndex, targetRotationAngle, steps, direction, state, getIndex(currentRotationIndex, direction, numFrames))
	return steps
		? Rx.Observable.from(steps)
			.scan((acc, step, i) => {
				return {
					s: getIndex(acc.s, step, numFrames),
					h: acc.s
				}
			}, {
				s: currentRotationIndex,
				h: prevRotationIndex
			})
			.concatMap(step => {
				return Rx.Observable.of({
					showIndex: step.s,
					hideIndex: step.h
				}).delay(50);
			})
		: Rx.Observable.of({
			showIndex: getIndex(currentRotationIndex, direction, numFrames),
			hideIndex: currentRotationIndex
		});
}